import { render } from "./PassportIcon.vue?vue&type=template&id=f2f6e200"
import script from "./PassportIcon.vue?vue&type=script&lang=js"
export * from "./PassportIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__